import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSSObject, Group, Stack } from '@mantine/core';
import { Switch, withStyles } from '@material-ui/core';
import { beam } from '@styles/colors/themes';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';
import TYPOGRAPHY_FLAT from '@styles/fonts/fontsizes/typography-flat';
import { typeCSS } from '@utils/TypeCSS.styles';
import styled, { css } from 'styled-components';

interface DataInputProps {
  isDisabled?: boolean;
  isVisible?: boolean;
}

export const StyledInput = styled.input`
  width: 209px;
  height: 42px;
  border-radius: 8px;
  font-size: 14px;
  color: ${beam.font.primary};
  background: #fff;
  align-items: start;
  padding-left: 10px;
  padding-right: 8px;
  border: 1px solid #d8dae5;
  box-sizing: border-box;

  :disabled {
    background-color: #f5f7fb;
    border: 1px solid #e9edf1;
    color: #8f95b2;

    ::placeholder {
      color: #c1c4d6;
    }
  }
  ::placeholder {
    color: ${beam.font.label};
  }
`;
StyledInput.displayName = 'StyledInput';

export const StyledTextArea = styled.textarea`
  width: 209px;
  height: 60px;
  border-radius: 8px;
  font-size: 14px;
  color: ${beam.font.primary};
  background: #fff;
  align-items: start;
  padding: 10px 16px;
  border: 1px solid #e9edf1;
  box-sizing: border-box;

  :disabled {
    background-color: #f5f7fb;
    border: 1px solid #e9edf1;
    color: #8f95b2;
    ::placeholder {
      color: #c1c4d6;
    }
  }
  ::placeholder {
    color: ${beam.font.label};
  }
  &.resize-x {
    resize: horizontal;
  }
`;
StyledTextArea.displayName = 'StyledTextArea';
export const StyledDiv = styled.div`
  color: ${beam.font.label};
`;
export const BigUniqueFieldDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 42px;
  border-radius: 8px;
  font-size: 14px;
  color: ${beam.font.label};
  background: #fff;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid #d8dae5;
  padding-left: 16px;
`;
export const GlobalInputContainer = styled.div`
  /* Layout Properties */
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 24px;
`;
export const EquipmentsListContainer = styled.div`
  /* Layout Properties */
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 16px;
`;
export const EquipmentsListContainerDescription = styled(
  EquipmentsListContainer,
)`
  /* Layout Properties */
  margin-bottom: 56px;
`;
export const InputsContainer = styled.div`
  /* Layout Properties */
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
`;
export const RowContainer = styled.div`
  /* Layout Properties */
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-items: center;
`;
/** This is both used to size inputs and as a spacer div where we don't need all */
export const InputDiv = styled.div`
  /* Layout Properties */
  display: flex;
  flex-direction: column;
  width: 209px;
  justify-content: center;
  align-items: start;
  & .react-date-picker {
    & .react-date-picker__wrapper {
      border: none;
      height: 100%;
      display: flex;
      justify-content: center;
    }
    & .react-calendar {
      width: 400px !important;
      display: table-caption;
    }
  }
  & .MuiInputBase-root {
    width: 209px;
  }
`;
InputDiv.displayName = 'InputDiv';

// Todo: make dynamic based on parent width.
export const BigInputDiv = styled(InputDiv)`
  /* Layout Properties */
  width: 326px;
  /* Checkbox input */
  & .checkbox-wrap {
    display: flex;
  }
  & .MuiInputBase-root {
    width: 326px;
  }
  &.tags {
    grid-column: 1/-1;
    width: 100%;
  }
`;
BigInputDiv.displayName = 'BigInputDiv';
export const BigInputDivDescription = styled(BigInputDiv)`
  /* Layout Properties */
  margin-bottom: -40px;
`;
BigInputDivDescription.displayName = 'BigInputDivDescription';
export const InputDivDescription = styled(InputDiv)`
  /* Layout Properties */
  margin-bottom: -40px;
`;
export const SmallInputDiv = styled(InputDiv)`
  /* Layout Properties */
  width: 169px;
`;
export const BigInputRowDiv = styled.div`
  /* Layout Properties */
  display: flex;
  flex-direction: row;
`;
BigInputRowDiv.displayName = 'BigInputRowDiv';
export const SmallInputRowDiv = styled(SmallInputDiv)`
  /* Layout Properties */
  flex-direction: row;
`;
export const InputRowDiv = styled(InputDiv)`
  /* Layout Properties */
  flex-direction: row;
`;
export const BigInputRowDivMarginZero = styled(BigInputDiv)`
  /* Layout Properties */
  flex-direction: row;
  margin-left: 0;
`;
export const SmallInputRowDivMarginZero = styled(SmallInputDiv)`
  /* Layout Properties */
  flex-direction: row;
  margin-left: 0;
`;
export const InputRowDivMarginZero = styled(InputDiv)`
  /* Layout Properties */
  flex-direction: row;
  margin-left: 0;
`;
export const Text = styled.div`
  font-style: normal;
  font-weight: 400;
  height: 40px;
  white-space: nowrap;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 14px;
  text-align: left;
  align-self: flex-end;

  margin-right: 8px;
  cursor: pointer;
  color: #474d66;
`;
export const P200 = styled.p`
  ${typeCSS(TYPOGRAPHY_FLAT.p200, true)}
  margin: 0;
`;
export const SmallText = styled(Text)`
  font-size: 10px;
  cursor: auto;
  margin-right: 4px;
  &[data-disabled='true'] {
    color: #8f95b2;
  }
`;
export const GlobalHeader = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 8px;
  color: #474d66;
`;
GlobalHeader.displayName = 'GlobalHeader';
export const Line = styled.div`
  margin-bottom: 24px;
  border: 1px solid #e9edf1;
  height: 0;
  width: 100%;
`;
export const LineDescription = styled(Line)`
  margin-top: 56px;
`;
export const ContainerOverflow = styled.div`
  overflow-y: auto;
  display: flex;
  height: 329px;
  flex-direction: column;
  width: 100%;
  &.rm-overflow-x {
    /* Hide overflow for now. Todo: Fixup AssigneeBody */
    overflow-x: hidden;
  }
`;
ContainerOverflow.displayName = 'ContainerOverflow';
export const ContainerColumn = styled.div`
  overflow-x: hidden;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
`;
export const Label = styled.div`
  display: flex;
  align-items: center;
  color: ${beam.font.primary};
  overflow-x: hidden;
  overflow-y: hidden;
  font-size: 14px;
  width: 100%;
  column-gap: 16px;
`;

export const BigStyledInput = styled(StyledInput)`
  width: 326px;
`;
BigStyledInput.displayName = 'BigStyledInput';
export const BigStyledTextArea = styled(StyledTextArea)`
  width: 326px;
`;
const TextBase = styled.p`
  margin: 0;
`;
TextBase.displayName = 'TextBase';
interface LabelTextProps {
  isDisabled?: boolean;
  disableAfter?: boolean;
}
export const ProductName = styled(TextBase)<LabelTextProps>`
  color: ${({ isDisabled }) =>
    isDisabled ? COLORS_FLAT.n600 : beam.font.primary};
  font-size: 12px;
  white-space: nowrap;
`;
ProductName.displayName = 'ProductName';

export const SerialName = styled(ProductName)`
  font-size: 14px;
`;

export const BigInputWithCheckBox = styled(StyledInput)<DataInputProps>`
  width: ${({ isVisible }) => (isVisible ? '270px' : '326px')};
  border-radius: ${({ isVisible }) => (isVisible ? '8px 0 0 8px' : '8px')};
  :disabled {
    background: #fff;
    border: 1px solid #d8dae5;
    ::placeholder {
      color: #8f95b2;
    }
  }
  &[data-disabled='true'] {
    background-color: #f5f7fb;
    color: #8f95b2;
  }
`;
export const SmallInputWithCheckBox = styled(BigInputWithCheckBox)`
  width: ${({ isVisible }) => (isVisible ? '113px' : '169px')};
`;
export const InputWithCheckBox = styled(BigInputWithCheckBox)`
  width: ${({ isVisible }) => (isVisible ? '164px' : '220px')};
`;
export const CheckBoxDiv = styled.div`
  width: 56px;
  height: 42px;
  font-size: 10px;
  color: ${beam.font.primary};
  background: #fff;
  border: 1px solid #d8dae5;
  box-sizing: border-box;
  border-radius: 0 8px 8px 0;
  border-left: none;
  display: flex;
  justify-content: center;
  align-items: center;
  & .MuiFormControlLabel-root {
    margin: 0 !important;
  }

  :disabled {
    background: #f0f0f0;
    border: 1px solid #e9edf1;
    ::placeholder {
      color: ${beam.font.primary};
    }
  }
  ::placeholder {
    color: #8f95b2;
  }
`;
const PurpleSwitch = withStyles({
  switchBase: {
    color: '#F0F0F0',

    '&$checked': {
      color: beam.color.primaryBlue,
    },

    '&$checked + $track': {
      backgroundColor: beam.color.primaryBlue,
      border: `none`,
    },
  },
  checked: {},
  track: {
    backgroundColor: beam.color.pureWhite,
    border: `1px solid ${beam.border.back}`,
    opacity: 1,
  },
})(Switch);

export const SwitchStyled = styled(PurpleSwitch)`
  margin-right: 8px !important;
`;
export const YesOrNo = styled(Text)`
  margin-right: 0;
  width: 150px !important;
  justify-content: flex-start;
  display: flex;
  box-sizing: border-box;
`;
export const Image = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  object-fit: cover;
`;
export const WindowButtonImage = styled.img``;
export const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: -14px;
`;

export const ChangesText = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #696f8c;
`;

export const SaveDiv = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #1371fe;
  cursor: pointer;
  padding: 14px 16px;
  gap: 8px;
  border: 0;
  border-radius: 8px;
  background-color: transparent;

  && {
    transition-duration: 0.2s;
    transition-property: background-color;
    transition-timing-function: var(--transition-fn);
  }
  :disabled {
    color: #c1c4d6;
    cursor: not-allowed;
  }

  :hover {
    background-color: #f6f8ff;
  }
`;
export const AddProductDiv = styled(SaveDiv)`
  justify-content: flex-start;
`;
export const IconSaveAwesome = styled(FontAwesomeIcon)`
  width: 13px;
  height: 16px;
  margin-right: 8px;
  margin-top: 2px;
`;

export const AddText = styled.span`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  cursor: pointer;
  /* identical to box height */

  /* beam-colors/beam-accent */
  color: #1371fe;
`;
AddText.displayName = 'AddText';

export const Block = styled.div`
  background: #fff;
  box-shadow: rgb(0 0 0 / 16%) 0 4px 12px;
  border-radius: 8px;
  position: absolute;
  padding: 16px 0;
  top: 60px;
  min-width: 204px;
  &[data-position='ADD-MORE'] {
    top: 70px;
    right: 400px;
  }
  &[data-position='CLOSE'] {
    right: 26px;
  }
`;
Block.displayName = 'Block';
export const ItemListFirst = styled.div`
  padding-top: 8px;
  padding-bottom: 8px;
  border-radius: 0;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  color: ${beam.font.primary};

  cursor: pointer;
  font-size: 14px;
  :hover {
    background: ${beam.background.card};
  }

  &.error {
    color: ${beam.font.error};
  }
`;
ItemListFirst.displayName = 'ItemListFirst';
export const IconImgAwesome = styled(FontAwesomeIcon)`
  color: ${beam.font.label};
  width: 14px;
  height: 14px;
  margin-right: 8px;
`;

export const HeaderInputsDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

interface IWrapper {
  disableShrink?: boolean;
}
const DisableShrink = css`
  flex-shrink: 0;
`;
export const Wrapper = styled.div<IWrapper>`
  display: flex;
  width: 150px;
  margin-right: 17px;
  align-self: flex-end;
  ${({ disableShrink }) => (disableShrink ? DisableShrink : '')}
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;
export const AssigneeRow = styled(Row)`
  margin-bottom: 16px;
`;
AssigneeRow.displayName = 'AssigneeRow';
interface IAddMoreButton {
  display?: boolean;
}

// Nb: Also used for TagsBody's assign tag to all,etc
export const AddMoreButton = styled.button<IAddMoreButton>`
  display: ${({ display }) => (display ? 'none' : 'flex')};
  flex-direction: row;
  border: 0;
  border-radius: 8px;
  background-color: transparent;
  padding: 14px 16px;
  gap: 10px;
  align-items: center;

  color: #1371fe;
  font-size: 14px;
  font-weight: 500;
  && {
    transition-duration: 0.2s;
    transition-property: background-color;
    transition-timing-function: var(--transition-fn);
  }

  :hover {
    background-color: #e6edff;
  }
  :disabled {
    cursor: not-allowed;
    color: #8f95b2;
    background-color: #edeff4;
    &:hover {
      background-color: #edeff4;
    }
  }
  flex-shrink: 0;
`;
AddMoreButton.displayName = 'AddMoreButton';
export const IconsWrapper = styled.div`
  margin-top: 3px;
`;

interface IDivider {
  height?: string;
}

export const Divider = styled.div<IDivider>`
  height: ${({ height }) => height};
`;

export const AssigneeWrapper = styled.div`
  padding: 5px 8px;
  border-radius: 8px;
  border: 1px solid #d8dae5;
`;

export const Scroll: CSSObject = {
  height: 329,
  overflowY: 'auto',
};
export const EqGrp: CSSObject = {
  // Same as Title width + margins (150 + 13 + 17)
  width: 183,
  overflow: 'hidden',
  color: beam.font.primary,
  flexShrink: 0,
};

export const HeadStack = styled(Stack)`
  max-width: calc(100% - 150px - 16px - 17px);
`;
export const TagGroup = styled(Group)`
  overflow-x: hidden;

  position: relative;

  &[data-overflow='true']::after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    /* Fade from transparent at the end to what the background is */
    background: linear-gradient(90deg, rgba(0, 0, 0, 0) 74%, #fff 97%);
    /* Allow interaction with the tags focus */
    pointer-events: none;
  }
`;

export const InputGrid = styled.div`
  display: grid;
  grid-template-columns: 162.825px calc(100% - 162.825px - 16px);
  column-gap: 16px;
`;
export const InputList = styled.div`
  --input-size: 326px;
  width: 100%;
  display: grid;
  column-gap: 16px;
  grid-template-columns: repeat(auto-fit, var(--input-size));

  &.three {
    --input-size: 209px;
  }
  &.tags {
    grid-template-columns: 100%;
  }
`;
export const TAG_SX: CSSObject = {
  width: '100%',
  '&[data-size="0"]': { columnGap: 0 },
};
